import * as React from 'react';
import { IContainerProps } from '../../../Container.types';
import { ContainerLogic } from '../../shared/ContainerLogic';
import styles from './VerticalRibbonArea.scss';

const VerticalRibbonArea: React.FC<IContainerProps> = props => {
  return (
    <ContainerLogic
      {...props}
      className={styles.root}
      renderSlot={({ containerChildren }) => (
        <>
          <div className={styles.bg} />
          <i className={styles.i}>
            <b className={styles.l} />
            <b className={styles.r} />
          </i>
          {containerChildren}
        </>
      )}
    />
  );
};

export default VerticalRibbonArea;
